import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import type { CombinatorSelectorProps } from 'react-querybuilder';

export enum LogicalOperator {
  AND = 'and',
  OR = 'or',
}

const CustomCombinator: React.FC<CombinatorSelectorProps> = ({
  value,
  disabled,
  handleOnChange,
}) => (
  <div className="custom-combinator-container">
    <ButtonGroup variant="outlined" disabled={disabled}>
      <Button
        className={
          value == LogicalOperator.OR
            ? 'active-custom-combinator-btn custom-combinator-btn'
            : 'custom-combinator-btn'
        }
        onClick={() => handleOnChange(LogicalOperator.OR)}
        disabled={disabled}
      >
        or
      </Button>
      <Button
        className={
          value == LogicalOperator.AND
            ? 'active-custom-combinator-btn custom-combinator-btn'
            : 'custom-combinator-btn'
        }
        onClick={() => handleOnChange(LogicalOperator.AND)}
        disabled={disabled}
      >
        and
      </Button>
    </ButtonGroup>
  </div>
);

export default CustomCombinator;
